import { ReactComponent as Rocket } from "./rocket.svg";
import DashboardHome from "./dash_home.png";
import DashboardOrganization from "./dash_organization.png";
import DashboardPendingEvaluations from "./dash_pending_evaluations.png";
import DashboardModifyQuestionnaire from "./dash_modify_questionnaire.png";
import DashboardManageRequests from "./dash_lock.png";
import DashboardCustomerSupport from "./dash_complaint.png";
import Document from "./document.png";

import { ReactComponent as Logout } from "./log-out.svg";
import { ReactComponent as ChevLeft } from "./chev-left.svg";
import { ReactComponent as ChevRight } from "./chev-right.svg";
import { ReactComponent as Mail } from "./mail.svg";
import { ReactComponent as Lock } from "./lock.svg";
import { ReactComponent as Eye } from "./eye.svg";
import { ReactComponent as EyeDisable } from "./eye-disable.svg";
import { ReactComponent as Hamburger } from "./hamburger.svg";
import { ReactComponent as DropDown } from "./dropDown.svg";
import { ReactComponent as Phone } from "./phone.svg";
import { ReactComponent as Cross } from "./cross.svg";
import { ReactComponent as Trash } from "./trash.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as ChevUp } from "./chev-up.svg";
import { ReactComponent as ChevDown } from "./chev-down.svg";
import { ReactComponent as TrashOutline } from "./trash-outline.svg";
import { ReactComponent as User } from "./user.svg";
import { ReactComponent as ArrowLeft } from "./arrow-left.svg";
import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as CameraPlus } from "./camera-plus.svg";
import { ReactComponent as Logo } from "./nav-logo.svg";
import { ReactComponent as LinkedInIcon } from "./linkedin-icon.svg";
import { ReactComponent as Bell } from "./bell.svg";
import { ReactComponent as LogoNoText } from "./logo-no-text.svg";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as ClipboardWithPencil } from "./clipboard_pencil.svg";
import { ReactComponent as WatchLater } from "./watch-later.svg";
import { ReactComponent as Filter } from "./filter.svg";
import { ReactComponent as Pencil } from "./pencil.svg";
import { ReactComponent as TrashOutline2 } from "./trash-outline-2.svg";
import { ReactComponent as VerticalDots } from "./vertical-dots.svg";
import { ReactComponent as FlagFill } from "./flag-fill.svg";
import { ReactComponent as Mail2 } from "./mail-2.svg";
import { ReactComponent as Success } from "./success.svg";
import { ReactComponent as QuestionaireIcon } from "./questionaire.svg";
import { ReactComponent as SubmitIcon } from "./submit.svg";
import { ReactComponent as ScoreIcon } from "./score.svg";
import { ReactComponent as TestomonialComma } from "./testimonial-comma.svg";
import { ReactComponent as Verified } from "./verified.svg";
import { ReactComponent as Tick } from "./tick.svg";
import { ReactComponent as SortDescending } from "./sort-descending.svg";
import { ReactComponent as ArrowRightOutline } from "./arrow-right-outline.svg";
import { ReactComponent as LogoABR } from "./logo-abr.svg";
import { ReactComponent as Archive } from "./archive.svg";
import { ReactComponent as SortAscending } from "./sort-ascending.svg";
import { ReactComponent as ClipboardWithBG } from "./clipboard-with-bg.svg";
import { ReactComponent as Clipboard } from "./clipboard.svg";
import { ReactComponent as FlagOutline } from "./flag-outline.svg";
import { ReactComponent as Evaluation } from "./evaluation.svg";
import { ReactComponent as Bill } from "./bill.svg";
import { ReactComponent as PlusCircle } from "./plus-circle.svg";
import { ReactComponent as Pin } from "./pin.svg";
import { ReactComponent as SortArrowDown } from "./sort-arrow-down.svg";
import { ReactComponent as Reply } from "./reply.svg";
import { ReactComponent as SortArrowUp } from "./sort-arrow-up.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as UplaodFile } from "./upload-file.svg";
import { ReactComponent as File } from "./file.svg";

const Icons = {
  DashboardHome,
  DashboardOrganization,
  DashboardPendingEvaluations,
  DashboardModifyQuestionnaire,
  DashboardManageRequests,
  DashboardCustomerSupport,
  Rocket,
  Logout,
  ChevLeft,
  ChevRight,
  Mail,
  Lock,
  Eye,
  EyeDisable,
  Hamburger,
  DropDown,
  Phone,
  Cross,
  Trash,
  Search,
  ChevUp,
  ChevDown,
  TrashOutline,
  User,
  ArrowLeft,
  ArrowRight,
  CameraPlus,
  Logo,
  LinkedInIcon,
  Bell,
  LogoNoText,
  Plus,
  ClipboardWithPencil,
  WatchLater,
  Filter,
  Pencil,
  TrashOutline2,
  VerticalDots,
  FlagFill,
  Mail2,
  Success,
  QuestionaireIcon,
  SubmitIcon,
  ScoreIcon,
  TestomonialComma,
  Verified,
  Tick,
  SortDescending,
  ArrowRightOutline,
  LogoABR,
  Archive,
  SortAscending,
  ClipboardWithBG,
  Clipboard,
  FlagOutline,
  Evaluation,
  Bill,
  PlusCircle,
  Pin,
  SortArrowDown,
  Reply,
  SortArrowUp,
  Download,
  Document,
  UplaodFile,
  File,
};

export { Icons };
